module.exports = __webpack_public_path__ + "media/images/flags/ck-af7bee35bddbd758ce1eda86dd76da1f.svg";